import React from 'react';
import { Chip } from '@mui/material';

const CONFIG = {
  quotation:     { label: 'QT ใบเสนอราคา',      color: '#E87722' },
  delivery_note: { label: 'DN ใบส่งงาน',         color: '#7B61FF' },
  billing_note:  { label: 'BL ใบวางบิล',         color: '#7B61FF' },
  receipt:       { label: 'REC ใบเสร็จรับเงิน',  color: '#059669' },
  tax_invoice:   { label: 'INV ใบกำกับภาษี',    color: '#2196F3' },
};

export default function DocumentTypeBadge({ type, size = 'small' }) {
  const cfg = CONFIG[type] || { label: type, color: '#888' };
  return (
    <Chip
      label={cfg.label}
      size={size}
      sx={{ fontWeight: 600, bgcolor: cfg.color, color: '#fff' }}
    />
  );
}
